import React from "react";
var __jsx = React.createElement;
import DhamenInfoForm from "@/pages/checkout/dhamen/components/DhamenFormScreen/InfoForm";
import { twMerge } from "tailwind-merge";
import useIsMobile from "@hooks/useIsMobile";
import { useTranslation } from "@i18n";
import OrderData from "@/pages/checkout/dhamen/components/DhamenFormScreen/OrderData";
import { useDhamenContext } from "@/common/Contexts/DhamenContextProvider";
import stl from "@/pages/checkout/finance-checkout/FreeFinanceFormPage.module.css";
function DhamenFormScreen(_ref) {
  var initialTab = _ref.initialTab;
  var isMobile = useIsMobile();
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _useDhamenContext = useDhamenContext(),
    state = _useDhamenContext.state,
    actions = _useDhamenContext.actions;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto !w-[80%] max-w-[1152px] max-lg:!w-[90%] after:content-[''] after:fixed after:bottom-0 after:left-0 after:w-full after:h-full after:z-[-1] after:bg-[#ffffff] sm:after:bg-[#fafcff] !mt-0 md:!mt-8"
  }, !isMobile && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between py-4"
  }, /*#__PURE__*/React.createElement("button", {
    className: ["whtBtn", stl.backBtn].join(" "),
    onClick: actions.handleBackClick
  }, tShort("dhamen/back")), /*#__PURE__*/React.createElement("button", {
    className: ["whtBtn", stl.backBtn].join(" "),
    onClick: actions.toggleClosingModal
  }, t("cancel", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement("div", {
    className: twMerge("flex flex-col-reverse sm:flex-row items-start justify-between pb-10 mt-0", !isMobile && "gap-[22px] md:!mt-4")
  }, /*#__PURE__*/React.createElement(DhamenInfoForm, null), !isMobile && /*#__PURE__*/React.createElement("div", {
    className: "w-full sm:min-w-[444px] sm:max-w-[444px]"
  }, /*#__PURE__*/React.createElement(OrderData, null)))));
}
export default DhamenFormScreen;